// old format
// <h6>
//   <Link to={'/'}>Go to Home</Link>
// </h6>

import PropTypes from 'prop-types'
import { homePageUrl } from '../constants'

const GoToHomeLink = ({ className = '' }) => {
  return (
    <a href={homePageUrl} className={className}>
      Go to Home
    </a>
  )
}

// prop validation
GoToHomeLink.propTypes = {
  className: PropTypes.string,
}

export default GoToHomeLink
